import UserAddUSelect from "./user-add-select";
import UserLanguageSelect from "./user-language-select";


const UserFormItems = {
    AddUserSelect: UserAddUSelect,
    LanguageSelect: UserLanguageSelect,
};

export default UserFormItems;